module.exports = __webpack_public_path__ + "static/media/5 3 tattoo leg sleeve elf eagle skull fantasy epic.1280x1707.9fbc3aca.webp";